<template>
  <app-notification
    :type="type"
    v-if="procedure_notification"
  >
    <app-payment-logo
      class="margin__b--12"
      :type="paymentMethod"
      :size="6"
      v-if="showPaymentMethod"
    />

    <h2
      class="bold"
      v-if="title"
    >
      {{ t(title) }}
    </h2>

    <p
      class="margin__t--6"
      v-if="text"
    >
      {{ t(text) }}
    </p>
  </app-notification>
</template>

<script setup>
import { computed, defineAsyncComponent, inject } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useNotificationStore } from '@/stores/NotificationStore'
import { useProcedureTransactionPaymentMethod } from '@/composables/modules/procedures'
import { useI18n } from '@/vendors/i18n'

const AppNotification = defineAsyncComponent(() => import('&/atoms/AppNotification'))
const AppPaymentLogo = defineAsyncComponent(() => import('&/atoms/AppPaymentLogo'))

const procedure_execution = inject('procedure_execution')

const { t } = useI18n()
const { $resetStore } = useNotificationStore()
const { procedure_notification } = storeToRefs(useNotificationStore())
const { paymentMethod } = useProcedureTransactionPaymentMethod({ procedure_execution })

const type = computed(() => procedure_notification.value?.type)
const title = computed(() => procedure_notification.value?.title)
const text = computed(() => procedure_notification.value?.text)
const showPaymentMethod = computed(() => procedure_notification.value?.show_payment_method || false)

onBeforeRouteLeave(() => $resetStore('procedure_notification'))
</script>

<style scoped lang="scss">
.notification.notification {
  padding: 18px;
}
</style>